export default __webpack_public_path__ + "static/media/OpelNextLight.ae670c7d.otf";